import { render, staticRenderFns } from "./UpdateBucketLimit.vue?vue&type=template&id=93fe1b38"
import script from "./UpdateBucketLimit.vue?vue&type=script&lang=js"
export * from "./UpdateBucketLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports